import store from '../store'
import {DateTime} from 'luxon';
import config from "../config";


/**
 * vuex падла кеширует результат выполнения геттера, если нужные ему значения в store не меняются
 * из-за того что результат этой функции зависит от текущего времени - пришлось вынести в хелперы.
 * @return bool
 */
export let canSendMessage = function(){
  let lastContactUsSent = store.getters['getLastContactUsSent']
  if (!lastContactUsSent) return true;

  let dtLastContactsUsSent = DateTime.fromISO(lastContactUsSent);
  let dtCurrent = DateTime.local();

  //длительность в минутах с момента последней отправки
  let durMin = dtCurrent.diff(dtLastContactsUsSent, 'minutes').minutes;
  if (durMin >= config.get('sendInterval')) return true

  return false;
}



// WEBPACK FOOTER //
// ./src/helpers/vuexFixes.js